import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=5bfdffbc&scoped=true"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"
import style0 from "./Report.vue?vue&type=style&index=0&id=5bfdffbc&prod&lang=less&scoped=true"
import style1 from "./Report.vue?vue&type=style&index=1&id=5bfdffbc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfdffbc",
  null
  
)

export default component.exports